import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { trainerList } from "../../../actions/admin/trainer/trainer_action";
import AppBody from "../../components/AppBody";

const TrainerList = () => {
  const state = useSelector((state) => state.trainerReducer);
  const dispatch = useDispatch("");
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(trainerList());
  }, []);

  const editTreainerClick = () => {
    navigate("/trainer/update/:id");
  };

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0  shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <Link to={"/"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Trainer List
              </h4>
              <div className="col text-right pr-0">
                <Link to={"/trainer/register"}>
                  <a
                    className="line-height-36 custom-icon mr-2"
                    title="Trainer Register"
                  >
                    <i className="feather-plus-circle"></i>
                  </a>
                </Link>
              </div>
            </div>
            <div className="card-body  p-4 w-100 border-0 ">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.list &&
                      state.list.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{li.first_name}</td>
                          <td>{li.last_name}</td>
                          <td>{li.email}</td>
                          <td>{li.mobile_no}</td>
                          <td>
                            <a
                              className="line-height-36 custom-icon mr-2"
                              title="Update"
                              target="_blank"
                              onClick={() => editTreainerClick(li.id)}
                            >
                              <i className="feather-edit"></i>
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default TrainerList;
